import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import ShopDisplay from '../shopDisplaySketchMap/display';
import style from './style.vue';
import { QinggerLibUtils } from '@/util';
import ShopDisplayEdit from '@/views/components/shopDisplaySketchMap/displayEdit';
import { IPSService } from '@/services/ipsServices';
const isset = QinggerLibUtils.isset;

@DialogFactory
@Component({})
export default class PrimaryGoods extends IPSDialog {
  title = '分类编辑';
  disabled = false;
  width = '905px';
  data = {};
  siteId = 0;
  empCode = 0;
  classId = 0;

  siteCodes = [];

  sgId = 0;

  mod = 0;

  classList: [];

  attrButeList = [];

  coupon = 0;

  isHover = true;

  @Provide()
  get mode() {
    return Number(this.mod);
  }

  @Provide()
  openCoupon() {
    return this.coupon;
  }

  $refs: {
    goodForm: ElForm;
  };

  beforeClose() {
    this.$emit('hidden');
  }

  onConfirm() {
    if (!this.data[0].className) {
      this.$message.warning('请输入分类名称！');
      return;
    }
    for (const i of this.data[0].desc.list) {
      if (i.advPic === '') {
        this.$message.warning('请上传图片！');
        return;
      }
    }
    const advInfo = Object.assign({}, this.data[0].desc, { fieldType: 'HotAd' }, { hotAdvert: 1 }, { isActived: false });
    const postParams = {
      classId: this.classId,
      className: this.data[0].className,
      advInfo,
    };
    IPSService.firstClassEdit({ postParams }).then((res) => {
      if (res.result) {
        this.$message.success('保存成功');
        this.$emit('result', this.data);
        this.$emit('hidden');
      }
    });
  }

  renderContent(h) {
    return (
      <div>
        <el-form class="flex" ref="goodForm" label-width="80">
          <div class="r-pl-30 r-pt-20 wid-215">
            <el-form-item label="分类名称" rules={[{ required: true, message: '', trigger: 'change' }]}>
              <el-input class="wid-100" v-model={this.data[0].className} placeholder="商品名称" />
            </el-form-item>
            <el-form-item label="分类广告">
              <ShopDisplay class="r-ml-78" fromPage={'0'} classAd={true} v-model={this.data} />
            </el-form-item>
          </div>
          {/* {this.data[0].isActived && ( */}
          <div class="hei-240 r-mt-80 r-ml--12">
            <ShopDisplayEdit classAd={true} v-model={this.data[0]} attrButeList={this.attrButeList} ref="form" />
          </div>
          {/* )} */}
        </el-form>
      </div>
    );
  }
}
